@if (buttonOptions.isLink && !buttonOptions.disabled) {
  @if (inAppNavigation) {
    <a
      [attr.data-testId]="dataLabel()"
      [routerLink]="buttonOptions.url"
      [queryParams]="buttonOptions.queryParams || {}"
      [queryParamsHandling]="buttonOptions.queryParamsHandling || 'merge'"
      [class]="buttonOptions.variant"
      [class.loading]="loading()"
      [class.fill]="buttonOptions.fill"
      (focus)="onFocus.emit()"
      [tabIndex]="tabbable() ? 0 : -1"
    >
      <ng-container *ngTemplateOutlet="Content"></ng-container>
    </a>
  } @else {
    <a
      [attr.data-testId]="dataLabel()"
      [href]="buttonOptions.url"
      [class]="buttonOptions.variant"
      [class.fill]="buttonOptions.fill"
      [class.loading]="loading()"
      [target]="buttonOptions.target || '_self'"
      (focus)="onFocus.emit()"
      [tabIndex]="tabbable() ? 0 : -1"
    >
      <ng-container *ngTemplateOutlet="Content"></ng-container>
    </a>
  }
} @else {
  <button
    class="{{ buttonOptions.variant }} {{ buttonOptions.alignment || 'center' }}"
    [attr.data-testId]="dataLabel()"
    [attr.aria-pressed]="buttonOptions.pressed"
    [type]="buttonOptions.type || 'button'"
    [class.fill]="buttonOptions.fill"
    [class.loading]="loading()"
    (click)="loading() ? null : onClick.emit()"
    (focus)="onFocus.emit()"
    [tabIndex]="tabbable() ? 0 : -1"
    [disabled]="buttonOptions.disabled"
  >
    <ng-container *ngTemplateOutlet="Content"></ng-container>
    @if (loading()) {
      <app-loading-spinner [variant]="buttonOptions.variant === 'primary' ? 'white' : 'blue'" [size]="20" />
    }
  </button>
}

<ng-template #Content>
  <ng-content></ng-content>
</ng-template>
